import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { formatDisplayWeek, formatDisplayDate, formatAmount } from '../../helper';
import TotalsBar from '../../Pages/admin/shared/TotalsBar';

const HEAD_BG = "#0b3a66";
const WEEK_BG = "#19284a";

class Detail extends Component {
    render() {
        const d = this.props.ReportDetails || {};
        const weeks = d.weeks || [];
        const opening = Number(d.OPENING_BALANCE) || 0;
        const totalDelivery = Number(d.TOTAL_DELIVERY) || 0;
        const totalPayment = Number(d.TOTAL_PAYMENT) || 0;
        const netBalance = opening + totalDelivery - totalPayment;

        const body = [];
        weeks.forEach((wk, wIdx) => {
            const payments = wk.payments || [];

            // Week separator row (spans all columns).
            body.push(
                <TableRow key={`wk-${wIdx}`} style={{ background: WEEK_BG }} >
                    <TableCell colSpan={6} style={{ color: 'white', fontWeight: 700 }} >
                        {formatDisplayWeek(wk.WK)}
                    </TableCell>
                </TableRow>
            );

            if (payments.length === 0) {
                body.push(
                    <TableRow key={`wk-${wIdx}-empty`} className="table-rows" >
                        <TableCell align="right">{formatAmount(wk.DELIVERY)}</TableCell>
                        <TableCell colSpan={4} align="center" style={{ color: '#94a3b8' }} >No payments this week</TableCell>
                        <TableCell align="right">{formatAmount(0)}</TableCell>
                    </TableRow>
                );
            } else {
                payments.forEach((p, i) => {
                    body.push(
                        <TableRow key={`wk-${wIdx}-p-${i}`} className="table-rows" >
                            {i === 0 &&
                                <TableCell align="right" rowSpan={payments.length} style={{ verticalAlign: 'top', fontWeight: 600 }} >
                                    {formatAmount(wk.DELIVERY)}
                                </TableCell>
                            }
                            <TableCell className="report-label-cell" >{formatDisplayDate(p.PAY_DATE)}</TableCell>
                            <TableCell>{p.SHOP}</TableCell>
                            <TableCell>{p.ON_BEHALF_ACC}</TableCell>
                            <TableCell>{p.DESCRIPTION}</TableCell>
                            <TableCell align="right">{formatAmount(p.AMOUNT)}</TableCell>
                        </TableRow>
                    );
                });
            }
        });

        return (
            <section>
                <Row>
                    <Col md={12} >
                        <Paper>
                            <TableContainer className="report-table-container" >
                                <Table className="report-table pc-shrink-table" size="small" stickyHeader aria-label="warehouse balance ledger">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" style={{ background: HEAD_BG, color: 'white', fontWeight: 700 }} >WAREHOUSE DELIVERY</TableCell>
                                            <TableCell align="center" colSpan={5} style={{ background: HEAD_BG, color: 'white', fontWeight: 700 }} >PAYMENT BY SHOP</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="right" style={{ background: HEAD_BG, color: 'white' }} >AMOUNT</TableCell>
                                            <TableCell style={{ background: HEAD_BG, color: 'white' }} >DATE</TableCell>
                                            <TableCell style={{ background: HEAD_BG, color: 'white' }} >SHOP</TableCell>
                                            <TableCell style={{ background: HEAD_BG, color: 'white' }} >ON BEHALF ACC</TableCell>
                                            <TableCell style={{ background: HEAD_BG, color: 'white' }} >DESCRIPTION</TableCell>
                                            <TableCell align="right" style={{ background: HEAD_BG, color: 'white' }} >AMOUNT</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {weeks.length === 0 ?
                                            <TableRow>
                                                <TableCell colSpan={6} align="center" >No records in this range.</TableCell>
                                            </TableRow>
                                            :
                                            body
                                        }
                                        <TableRow style={{ background: '#e7e7e7' }} >
                                            <TableCell align="right" style={{ fontWeight: 800 }} >{formatAmount(totalDelivery)}</TableCell>
                                            <TableCell colSpan={4} style={{ fontWeight: 800 }} >Total</TableCell>
                                            <TableCell align="right" style={{ fontWeight: 800 }} >{formatAmount(totalPayment)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Col>
                </Row>

                <TotalsBar>
                        <span>BALANCE B/F: </span>
                        <span>£ {formatAmount(opening)}</span>
                        <span style={{ borderRight: '1px solid', margin: '0px 5px' }} ></span>
                        <span>DELIVERY: </span>
                        <span>£ {formatAmount(totalDelivery)}</span>
                        <span style={{ borderRight: '1px solid', margin: '0px 5px' }} ></span>
                        <span>PAYMENT: </span>
                        <span>£ {formatAmount(totalPayment)}</span>
                        <span style={{ borderRight: '1px solid', margin: '0px 5px' }} ></span>
                        <span style={{ fontWeight: 800 }} >NET BALANCE: </span>
                        <span style={{ fontWeight: 800 }} >£ {formatAmount(netBalance)}</span>
                    
                </TotalsBar>
            </section>
        );
    }
}

export default Detail;
